import { withGlobal } from "components/global/GlobalWrapper";
import BuildingStructures from "./BuildingStructures";
import { buildingStructuresReducers } from "components/stores/building_structures/reducers";

export default withGlobal(BuildingStructures, { reducers: buildingStructuresReducers });

